import React, { useContext, useState } from "react";
import {isNull, isUndefined} from "lodash";
import ListDisplayContext from "./ListDisplayContext";
import Modal from "react-modal";

const BrandSmall = ({ brand }) => {
    const { selectedBrand, setSelectedBrand, availableOptions } = useContext(ListDisplayContext);

    const redirectUrl = document.getElementsByClassName('amrest-brands-popup-big')[0].getAttribute('data-contact');

    const [selectedCountry, setSelectedCountry] = useState(0);

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            padding: '0'
        },
    };

    function closeModal() {
        setModalIsOpen(false);
        setSelectedCountry(0);
    }

    function afterOpenModal() {
    }

    function createHeader() {
        let brand = availableOptions.brands.filter(el => {
            return el.id === selectedBrand
        })[0];

        return ( brand ? (<div className="row">
            <div className="col-12">
                <img className="img-fluid desktop" src={brand.ourBrandPopupDesktopImg.url} alt={brand.ourBrandPopupDesktopImg.alt} width={brand.ourBrandPopupDesktopImg.width} height={brand.ourBrandPopupDesktopImg.height}/>
                <img className="img-fluid mobile" src={brand.ourBrandPopupMobileImg.url} alt={brand.ourBrandPopupMobileImg.alt} width={brand.ourBrandPopupMobileImg.width} height={brand.ourBrandPopupMobileImg.height}/>
            </div>
            <div className="col-12">
                <div className="name text-center">{brand.name}</div>
            </div>
            <div className="col-12">
                <div className="popup-title text-center">{brand.popupTitle}</div>
            </div>
            <div className="col-12">
                <div className="grey-border-bottom"></div>
            </div>
        </div>) : null);
    }

    function createCountryOptions() {
        let filteredCountriesBrands = [];
        for(let b = 0; b < availableOptions.brandsInCountries.length; b++ ) {
            if(availableOptions.brandsInCountries[b].brand == selectedBrand) {
                filteredCountriesBrands.push(availableOptions.brandsInCountries[b]);
            }
        }

        let options = [];

        for (let c = 0; c < filteredCountriesBrands.length; c++) {
            let country = availableOptions.countries.filter(el => {
                return el.id === filteredCountriesBrands[c].country
            })[0];
            options.push(<option value={country.id} key={"country" + (c) }>{country.name}</option>)
        }

        if (options.length > 0 && selectedCountry == 0) {
            setSelectedCountry(options[0].props.value);
        }

        return options;
    }

    function createButton() {
        let brandInCountry = availableOptions.brandsInCountries.filter(el => {
            return el.country == selectedCountry && el.brand == selectedBrand
        })[0];

        let valueBrand = '';
        let valueFranchise = '';
        let valueCareer = '';
        if (!isUndefined(brandInCountry)) {
            valueBrand = brandInCountry.field_our_brands_brand_url;
            valueFranchise = brandInCountry.field_our_brands_franchise_url;
            valueCareer = brandInCountry.field_our_brands_career_url;
        }

        return (
            <div className="row">
                {valueBrand !== '' ?
                    <div className="col-12 col-md-auto">
                        <a className="btn btn-outline-primary active" target="_blank" href={valueBrand}>{Drupal.t('Visit brand website')}</a>
                    </div>
                : null}
                {valueCareer !== '' ?
                <div className="col-12 col-md-auto">
                    <a className="btn btn-outline-primary" target="_blank" href={valueCareer}>{Drupal.t('Job opportunities')}</a>
                </div>
                : null}
                {valueFranchise !== '' ?
                <div className="col-12 col-md-auto">
                    <a className="btn btn-outline-primary" target="_blank" href={valueFranchise}>{Drupal.t('Franchise')}</a>
                </div>
                : null}
            </div>
        );
    }

    function handleChangeCountry(event) {
        let countryId = event.target.value;
        setSelectedCountry(countryId);
    }

    function createRichText() {
        let brandInCountry = availableOptions.brandsInCountries.filter(el => {
            return el.country == selectedCountry && el.brand == selectedBrand
        })[0];

        return (brandInCountry ? <div className="text" dangerouslySetInnerHTML={{__html: (brandInCountry.contactText ? brandInCountry.contactText : '')}}/>
            : null);
    }

    function createRichTexts() {
        let brand = availableOptions.brands.filter(el => {
            return el.id == selectedBrand
        })[0];

        return (brand ?
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="text text-1" dangerouslySetInnerHTML={{__html: (brand.rich1 ? brand.rich1 : '')}}/>
                </div>
                <div className="col-12 col-md-6">
                    <div className="text text-2" dangerouslySetInnerHTML={{__html: (brand.rich2 ? brand.rich2 : '')}}/>
                </div>
            </div>
            : null);
    }

    function createKeyFacts() {
        let brand = availableOptions.brands.filter(el => {
            return el.id == selectedBrand
        })[0];

        return (brand ?
            <div className="row">
                <div className="col-12">
                    <h2 className="h3">{Drupal.t("Key facts")}</h2>
                </div>
                <div className="col-12">
                    <div className="box-key-facts">
                        <div className="row row-cols-2 row-cols-lg-4">
                            <div className="col box-numbers-item box-numbers-item--new-red d-flex align-items-center">
                                <div>
                                    <img src={brand.field_key_facts_icon_1} alt={brand.field_key_facts_title_1}/>
                                    <p className="number text-nowrap">{brand.field_key_facts_title_1}</p>
                                    <p className="text">{brand.field_key_facts_text_1}</p>
                                </div>
                            </div>
                            <div className="col box-numbers-item box-numbers-item--new-gray d-flex align-items-center">
                                <div>
                                    <img src={brand.field_key_facts_icon_2} alt={brand.field_key_facts_title_2}/>
                                    <p className="number text-nowrap">{brand.field_key_facts_title_2}</p>
                                    <p className="text">{brand.field_key_facts_text_2}</p>
                                </div>
                            </div>
                            <div className="col box-numbers-item box-numbers-item--new-yellow d-flex align-items-center">
                                <div>
                                    <img src={brand.field_key_facts_icon_3} alt={brand.field_key_facts_title_3}/>
                                    <p className="number text-nowrap">{brand.field_key_facts_title_3}</p>
                                    <p className="text">{brand.field_key_facts_text_3}</p>
                                </div>
                            </div>
                            <div className="col box-numbers-item box-numbers-item--new-red d-flex align-items-center">
                                <div>
                                    <img src={brand.field_key_facts_icon_4} alt={brand.field_key_facts_title_4}/>
                                    <p className="number text-nowrap">{brand.field_key_facts_title_4}</p>
                                    <p className="text">{brand.field_key_facts_text_4}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : null);
    }

    function createImages() {
        let brand = availableOptions.brands.filter(el => {
            return el.id == selectedBrand
        })[0];
        return (brand ?
            <div className="row">
                <div className="col-12 col-sm-4">
                    <img className="img-fluid" src={brand.field_images[0].url} alt={brand.field_images[0].alt}/>
                </div>
                <div className="col-12 col-sm-4">
                    <img className="img-fluid" src={brand.field_images[1].url} alt={brand.field_images[1].alt}/>
                </div>
                <div className="col-12 col-sm-4">
                    <img className="img-fluid" src={brand.field_images[2].url} alt={brand.field_images[2].alt}/>
                </div>
            </div>
            : null);
    }

    if (selectedBrand === brand.id) {
        if (modalIsOpen) {
            return (
                <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel={Drupal.t('Find website')}
                    parentSelector={
                        () => document.getElementsByClassName('brand-container-' + selectedBrand)[0]
                    }
                >
                    <div className="row">
                        <div className="col-12">
                            <div className="header">
                                <button onClick={closeModal}></button>
                                {createHeader()}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <form className="col-12">
                            <div className="form-content">
                                <div className="form-content-wrapper wide">
                                    <div className="row">
                                        <div className="col-12 text-md-center">
                                            <h2 className="h3">{Drupal.t('Find website')}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-content-wrapper medium">
                                    <div className="row">
                                        <div className="col-12">
                                            <label className="col-form-label font-weight-bold">{Drupal.t('Select country')}:</label>
                                        </div>
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12 col-md-4">
                                                    <select className="form-control w-100"
                                                            onChange={handleChangeCountry}
                                                            value={selectedCountry}
                                                    >
                                                        {createCountryOptions()}
                                                    </select>
                                                </div>
                                                <div className="col-12 col-md-8">
                                                    {createButton()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-content-wrapper wide">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="grey-border-bottom"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-content-wrapper">
                                    <div className="row">
                                        <div className="col-md-9">
                                            <div className="row">
                                                <div className="col-12">
                                                    {createRichText()}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <a className="btn btn-outline-primary" href={redirectUrl}>{Drupal.t('Contact us')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="content">
                                {createRichTexts()}
                                {createKeyFacts()}
                                {createImages()}
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        } else {
            return  (<div className="align-items-center">
                        <div className="brand-small">
                            <div className="header">
                                <img src={brand.ourBrandSmallImg} alt={name} className="img-fluid"/>
                                <button onClick={() => setSelectedBrand(false)}></button>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="text" dangerouslySetInnerHTML={{__html: (brand.ourBrandSmallText ? brand.ourBrandSmallText : '')}}>
                                    </div>
                                </div>
                            </div>
                            <div className="buttons">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="btn btn-primary w-100" onClick={() => setModalIsOpen(true)}>
                                            {Drupal.t('KEY FACTS')}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {brand.website != '' ? (
                                            <a className="btn btn-outline-primary w-100" href={brand.website}>
                                                {Drupal.t('BRAND WEBSITE')}
                                            </a>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>);
        }
    } else {
        return null;
    }

};

export default BrandSmall;
